<template>
  <section class="main-container" >
    <div class="columns is-multiline is-desktop" v-if="userBoxes && userBoxes.length > 0">
      <div class="column">
        <h3 class="title is-spaced">Les meves iniciatives</h3>        
      </div>
      <div class="column is-one-third ">
        <router-link class="is-pulled-right button has-margin-bottom-2 is-danger" to="/edita">Crea una iniciativa</router-link>
      </div>
    </div>
    <div class="columns is-multiline is-desktop has-margin-top-2">
      <div class="column is-one-third" v-for="box in userBoxes" v-bind:key="box.id">
        <BoxItemDetail :box="box"></BoxItemDetail>
      </div>
    </div>

  </section>  
</template>

<script>
import { mapState } from "vuex";
const fb = require("../firebaseConfig.js");
import BoxItemDetail from '@/components/BoxItemDetail'

export default {
  components: {
    BoxItemDetail
  },
  computed: {
    ...mapState(["userProfile", "currentUser", "userBoxes"])
  },
  created () {
  },
  methods: {
  }
};
</script>



// WEBPACK FOOTER //
// src/components/MyBoxes.vue